import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Modal,
  Button,
  Form,
  Upload,
  Image,
  Select,
  Row,
  Col,
  Radio,
  Space,
  Checkbox,
  Slider,
  Spin,
} from "antd";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onClose } from "../../../Redux/UploadOrUpdateTrackSlice";
import { faFileArrowUp, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./UploadOrUpdateTrackModal.css";

const radioPrivacy = [
  { label: "Công khai", value: "public" },
  { label: "Chỉ những ai có đường liên kết", value: "onlyLinkReceiver" },
  { label: "Riêng tư", value: "private" },
];
const radioListens = [
  { label: "Mọi quyền được bảo lưu", value: "allRightsReserved" },
  { label: "Bản quyền mở", value: "creativeCommons" },
];
const creativeCommonOptions = [
  {
    label: (
      <div className="creativeCommonOptionWrapper">
        <span>Ghi công</span>
        <span>
          Cho phép người khác sao chép, phân phối, hiển thị và biểu diễn tác
          phẩm có bản quyền này nhưng chỉ khi họ ghi công theo cách bạn yêu cầu.
        </span>
      </div>
    ),
    value: "attribution",
  },
  {
    label: (
      <div className="creativeCommonOptionWrapper">
        <span>Phi thương mại</span>
        <span>
          Cho phép người khác phân phối, hiển thị và biểu diễn tác phẩm của bạn
          - cũng như các tác phẩm phái sinh dựa trên tác phẩm này - nhưng chỉ
          với mục đích phi thương mại.
        </span>
      </div>
    ),
    value: "nonCommercial",
  },
  {
    label: (
      <div className="creativeCommonOptionWrapper">
        <span>Không có tác phẩm phái sinh</span>
        <span>
          Cho phép người khác sao chép, phân phối, hiển thị và biểu diễn chỉ
          những bản sao chính xác tác phẩm của bạn, không phải các tác phẩm phái
          sinh dựa trên tác phẩm này.
        </span>
      </div>
    ),
    value: "noDelivativeWorks",
  },
  {
    label: (
      <div className="creativeCommonOptionWrapper">
        <span>Chia sẻ tương tự</span>
        <span>
          Cho phép người khác phân phối các tác phẩm phái sinh chỉ dưới một giấy
          phép giống hệt với giấy phép điều chỉnh tác phẩm của bạn.
        </span>
      </div>
    ),
    value: "shareAlike",
  },
];
const audioQualityMarks = {
  1: "64kbps",
  2: "96kbps",
  3: "128kbps",
  4: "320kbps",
};
const audioQualityReferVals = [64, 96, 128, 320];

function UploadOrUpdateTrackModal({ setDataUpdated }) {
  const dispatch = useDispatch();
  const { open, info } = useSelector((state) => state.uploadOrUpdateTrack);
  const [form] = Form.useForm();
  const [allValidated, setAllValidated] = useState(false);
  const [tempData, setTempData] = useState({});
  const [preview, setPreview] = useState({ src: "", open: false });
  const [checkboxOptions, setCheckboxOptions] = useState([]);
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(false);
  const ownerInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  useEffect(() => {
    const getGenres = async () => {
      try {
        const res = await axios.get(
          process.env.REACT_APP_SERVER_URL + "/genre/get-all"
          // { headers: { "Cache-Control": "no-cache" } }
        );
        const genres = res.data.map((genre) => ({
          label: genre.name,
          value: genre._id,
        }));
        setGenres(genres);
      } catch (err) {
        console.error("Error fetching genres:", err);
      }
    };
    if (genres.length === 0) {
      getGenres();
    }
  }, []);

  useEffect(() => {
    if (open && info) {
      form.setFieldsValue(info);
    }
    return () => form.resetFields();
  }, [open, info, form]);

  useEffect(() => {
    const validate = async () => {
      try {
        await form.validateFields();
        setAllValidated(true);
      } catch (err) {
        console.log(err);
      }
    };
    validate();
  }, [tempData, form]);

  useEffect(() => {
    if (open) {
      const checkboxDefaultValues = form.getFieldValue("creativeCommons") || [];
      setCheckboxOptions(checkboxDefaultValues);
    }
  }, [open, form]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreview({ src: file.url || file.preview, open: true });
  };

  const handleCheckboxChange = (checkedValues) => {
    let updatedValues = [...checkedValues];
    if (
      checkboxOptions.includes("noDelivativeWorks") &&
      updatedValues.includes("shareAlike")
    ) {
      updatedValues = updatedValues.filter(
        (option) => option !== "noDelivativeWorks"
      );
    }
    if (
      checkboxOptions.includes("shareAlike") &&
      updatedValues.includes("noDelivativeWorks")
    ) {
      updatedValues = updatedValues.filter((option) => option !== "shareAlike");
    }
    form.setFieldValue("creativeCommons", updatedValues);
    setCheckboxOptions(updatedValues);
  };

  const handleAddUpdateTrack = async () => {
    if (allValidated) {
      setLoading(true); // Turn on loading while waiting for API response
      const data = form.getFieldsValue();
      const formData = new FormData();
      if (data.audioFile) {
        formData.append("audio", data.audioFile);
      }
      if (data.avatar) {
        formData.append("image", data.avatar);
      }
      formData.append(
        "audioQuality",
        audioQualityReferVals[data.audioQuality - 1]
      );
      formData.append("publisher", ownerInfo?.id);
      formData.append("privacy", data.privacy);
      formData.append("artistName", data.artistName);
      formData.append("title", data.title);
      formData.append("genre", data.genre);
      if (
        data.additionTags &&
        Array.isArray(data.additionTags) &&
        data.additionTags.length > 0
      ) {
        const tagsArray = data.additionTags
          .flatMap((tag) => tag.split(","))
          .map((tag) => tag.trim())
          .filter((tag) => tag !== "");

        formData.append("tags", JSON.stringify(tagsArray));
      } else {
        formData.append("tags", JSON.stringify([]));
      }

      formData.append("description", data.description);
      formData.append("license", data.license);
      if (data.license === "creativeCommons") {
        const creativeCommonsArray =
          typeof data.creativeCommons === "string"
            ? data.creativeCommons.split(",").map((cc) => cc.trim())
            : data.creativeCommons;

        formData.append(
          "creativeCommons",
          JSON.stringify(creativeCommonsArray)
        );
      } else {
        formData.append("creativeCommons", JSON.stringify([]));
      }

      try {
        const res = await axios.post(
          process.env.REACT_APP_SERVER_URL + "/track/create",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res.status === 201) {
          setDataUpdated((prev) => !prev);
          setLoading(false); // Turn off loading once API response is received
          handleClose();
          toast.success("Đăng tải thành công");
        }
      } catch (err) {
        console.error("Upload error: ", err);
        toast.error("Đăng tải thất bại");
        setLoading(false);
      }
    }
  };

  const handleClose = () => {
    if (loading) return;
    form.resetFields();
    setPreview({ src: "", open: false });
    setTempData({});
    setAllValidated(false);
    dispatch(onClose());
  };

  return (
    <>
      <Modal
        className="uploadUpdateTrackModal"
        open={open}
        title={info ? "Cập nhật track" : "Đăng tải track"}
        onCancel={handleClose}
        footer={
          <>
            <Button
              disabled={!allValidated || loading}
              htmlType="submit"
              onClick={handleAddUpdateTrack}
              type="primary"
            >
              {info ? "Lưu thay đổi" : "Đăng tải track"}
            </Button>
            <Button disabled={loading} onClick={handleClose}>
              Hủy
            </Button>
          </>
        }
      >
        <Spin spinning={loading} tip="Đang bắt đầu đăng tải track...">
          <div className="trackModalWrapper">
            <Form
              layout="vertical"
              form={form}
              initialValues={
                {
                  artistName: ownerInfo?.username || "",
                  audioQuality: 3,
                  license: "allRightsReserved",
                  creativeCommons: [
                    "shareAlike",
                    "nonCommercial",
                    "attribution",
                  ],
                  privacy: "private",
                  ...info,
                } || {}
              }
              onValuesChange={(_, values) => setTempData(values)}
            >
              <Form.Item
                label="Audio file(track):"
                name="audioFile"
                getValueFromEvent={(e) => e?.fileList}
                rules={[
                  { required: true, message: "Thông tin không được để trống" },
                  {
                    validator(_, fileList) {
                      return new Promise((resolve, reject) => {
                        if (
                          fileList &&
                          fileList[0]?.size > 4 * 1024 * 1024 * 1024
                        ) {
                          reject("Kích cỡ file đã vượt quá 4GB");
                        } else {
                          resolve();
                        }
                      });
                    },
                  },
                ]}
              >
                <Upload.Dragger
                  maxCount={1}
                  accept=".wav,.mp3,.aiff,.pcm,.flac,.alac,.wv,.aac,.ogg,.wma,.midi,.dts,.ac3,.m3u,.asf,.amr,.aifc"
                  onChange={(data) =>
                    form.setFieldValue(
                      "audioFile",
                      data?.fileList[0]?.originFileObj || null
                    )
                  }
                  beforeUpload={() => false} // Disable auto upload
                >
                  <div className="uploadTrackBtn">
                    <FontAwesomeIcon
                      color="#1890ff"
                      size="2x"
                      icon={faFileArrowUp}
                    />
                    <p className="ant-upload-text modify">
                      Nhấn hoặc kéo thả file vào khu vực này để đăng tải
                    </p>
                    <p className="ant-upload-hint modify">
                      Để có chất lượng tốt nhất, hãy sử dụng các định dạng WAV,
                      FLAC, AIFF hoặc ALAC. Kích thước tệp tối đa là 4 GB không
                      nén.
                    </p>
                  </div>
                </Upload.Dragger>
              </Form.Item>
              <Form.Item
                label={
                  <span>
                    Chất lượng đăng tải:{" "}
                    <span className="audioQualityHint">
                      (64kbps: ưu tiên tốc độ tải, 320kbps: ưu tiên chất lượng
                      âm thanh)
                    </span>
                  </span>
                }
                name="audioQuality"
              >
                <Slider
                  marks={audioQualityMarks}
                  min={1}
                  max={4}
                  step={null}
                  tooltip={{ formatter: null }}
                  className="audioQualitySlider"
                />
              </Form.Item>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    label="Ảnh đại diện:"
                    name="avatar"
                    getValueFromEvent={(e) => e?.fileList}
                    rules={[
                      {
                        validator(_, fileList) {
                          return new Promise((resolve, reject) => {
                            if (
                              fileList &&
                              fileList[0]?.size > 5 * 1024 * 1024
                            ) {
                              reject("Kích cỡ file đã vượt quá 5MB");
                            } else {
                              resolve();
                            }
                          });
                        },
                      },
                    ]}
                  >
                    <div>
                      <Upload
                        listType="picture-card"
                        maxCount={1}
                        accept=".jpg,.jpeg,.png,.svg"
                        onPreview={handlePreview}
                        onChange={(data) =>
                          form.setFieldValue(
                            "avatar",
                            data?.fileList[0]?.originFileObj || null
                          )
                        }
                        beforeUpload={() => false} // Disable auto upload
                      >
                        <button className="uploadTrackAvatarBtn">
                          <FontAwesomeIcon icon={faPlus} />
                          <span>Chọn ảnh</span>
                        </button>
                      </Upload>
                      {preview?.src && (
                        <Image
                          wrapperStyle={{
                            display: "none",
                          }}
                          preview={{
                            visible: preview?.open,
                            onVisibleChange: (visible) =>
                              setPreview((prev) => ({
                                ...prev,
                                open: visible,
                              })),
                            afterOpenChange: (visible) =>
                              !visible &&
                              setPreview((prev) => ({ ...prev, src: "" })),
                          }}
                          src={preview?.src}
                        />
                      )}
                    </div>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Chế độ riêng tư:" name="privacy">
                    <Radio.Group>
                      <Space direction="vertical">
                        {radioPrivacy.map((item, index) => (
                          <Radio
                            className="radioOptions"
                            key={index}
                            value={item.value}
                          >
                            {item.label}
                          </Radio>
                        ))}
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Col span={11}>
                <Form.Item
                  label="Tác giả"
                  name="artistName"
                  rules={[
                    {
                      required: true,
                      message: "Thông tin không được để trống",
                    },
                  ]}
                >
                  <Input placeholder="Tên tác giả" />
                </Form.Item>
              </Col>
              <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[
                  { required: true, message: "Thông tin không được để trống" },
                ]}
              >
                <Input placeholder="Tên tiêu đề" />
              </Form.Item>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    label="Dòng nhạc:"
                    name="genre"
                    rules={[
                      {
                        required: true,
                        message: "Thông tin không được để trống",
                      },
                    ]}
                  >
                    <Select
                      size="small"
                      options={genres}
                      placeholder="Chọn dòng nhạc"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Bổ sung tag:" name="additionTags">
                    <Select
                      size="small"
                      showSearch
                      mode="tags"
                      options={genres.map((genre) => ({
                        label: genre.label,
                        value: genre.label,
                      }))}
                      placeholder="Thêm tag"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item label="Miêu tả:" name="description">
                <Input.TextArea
                  placeholder="Miêu tả"
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  count={{ show: true, max: 5000 }}
                />
              </Form.Item>
              <Form.Item label="Bản quyền:" name="license">
                <Radio.Group>
                  <Space direction="horizontal">
                    {radioListens.map((item, index) => (
                      <Radio
                        className="radioOptions"
                        key={index}
                        value={item.value}
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
              {tempData?.license === "creativeCommons" ? (
                <Form.Item name="creativeCommons">
                  <Checkbox.Group
                    className="creativeCommonsCheckboxGroup"
                    options={creativeCommonOptions}
                    onChange={handleCheckboxChange}
                  />
                </Form.Item>
              ) : (
                <Row>
                  <Col className="allRightsReservedRules" span={12}>
                    <span>Những người khác không được phép:</span>
                    <ul className="listOfRules">
                      <li>Tải về hoặc sao chép lại track này</li>
                      <li>Sử dụng bài nhạc vào mục đích thương mại</li>
                      <li>Chỉnh sửa hoặc tạo sản phẩm phái sinh</li>
                      <li>Chia sẻ dưới dạng thương mại</li>
                    </ul>
                  </Col>
                  <Col className="allRightsReservedRules" span={12}>
                    <span>Được phép:</span>
                    <ul className="listOfRules">
                      <li>Nghe, đăng lại và chia sẻ track này</li>
                      <li>Bày tỏ cảm xúc và bình luận</li>
                      <li>Thêm vào playlist</li>
                    </ul>
                  </Col>
                </Row>
              )}
            </Form>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default UploadOrUpdateTrackModal;
